/* eslint-disable @typescript-eslint/ban-types */
import { AbstractControl } from '@angular/forms';
import { FormMapper } from './form-mapper';

export abstract class FormConverter<DataModel, FormModel> {
  private formModel: Object;

  constructor(target: Object) {
    this.formModel = target;
  }

  public buildForm(data: DataModel): AbstractControl {
    return FormMapper.buildForm(this.formModel, this.toFormModel(data));
  }

  public buildObject(data: AbstractControl): DataModel | null {
    return this.toObject(data.getRawValue() as FormModel);
  }

  abstract toFormModel(data: DataModel): FormModel;
  abstract toObject(form: FormModel): DataModel | null;
}
